module.exports = __webpack_public_path__ + "img/c1.a6b8a4e9.png";